import ActionTypePlan from "../ActionTypePlan";
// import {ModosOp} from '../../../../_comun/reductores/Constantes'
import { TipoPlan, Udm} from "../../../../isp.žapi.planes/constantesApiPlanes";

export default class CargaDePlanConsultado extends ActionTypePlan {

    ejecutar(estado, nuevoEstado) {
        // nuevoEstado.domain.idCliente = this.payload.idCliente;
        // nuevoEstado.domain.fechaReg = this.payload.fechaReg;
        // nuevoEstado.domain.estado = this.payload.estado;
        // nuevoEstado.flag.procesandoComando = false;
        // nuevoEstado.flag.modoOperacion = ModosOp.OK;
        // Estado.Registrado = estado.domain;
        // Estado.ParaUpdate={};
        nuevoEstado.flag.modal = false;
        nuevoEstado.flag.cargandoEntidad = false;
        nuevoEstado.domain.screen = {...estado.domain.screen, ...this.payload};
        nuevoEstado.domain.screen.combos.tiposPlan=[nuevoEstado.domain.screen.tipoPlan]
        if (this.payload.tipoPlan === TipoPlan.ServiciosGen || this.payload.tipoPlan === TipoPlan.Articulo) {
            // nuevoEstado.domain.screen.udm=Udm.Unidad;
            
            nuevoEstado.domain.screen.combos.udms=[Udm.Unidad];
        }
        if (this.payload.tipoPlan === TipoPlan.PlanInternet) {
            // nuevoEstado.domain.screen.udm=Udm.Mensual;
            // nuevoEstado.domain.screen.combos.tiposPlan=[nuevoEstado.domain.screen.tipoPlan]
            nuevoEstado.domain.screen.combos.udms=[Udm.Mensual];
        }

        nuevoEstado.domain.cargado = JSON.parse(JSON.stringify(this.payload));
        nuevoEstado.domain.update = {}
        nuevoEstado.domain.nroUpdates= 0;

        return nuevoEstado;
    }

}